var basepath='./';
export const fridgeinstruction={
  fridgeTitle:'<p style=\'font-size:18px;color:#333333;margin-top:20px;\'>美菱冰箱、冰柜、洗衣机保修政策</p>',
  fridgeContent:'<p style=\'font-size:18px;color:#333333;margin-top: 10px;\' id="fridgeinstruction">国家“三包”规定</p>\n' +
  '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>'+
  '1.严格执行国家制定的《消费者权益保护法》、《产品质量法》、《部分商品修理、更换、退货的规定》。\n' +'<br>\n' +
  '2.用户自购买美菱产品之日起，7日内出现性能故障，免费给予修理、调换和退货（自收到商品之日起七天无理由退货仅适用于美菱电商网络销售的正品）；用户自购买美菱产品之日起，15日内出现性能故障，给予免费修理和调换，退货按国家规定收取折旧费。\n' +'<br>\n' +
  '</div>'+
  // '<p style=\'font-size:18px;color:#333333;margin-top: 10px;\'>美菱冰箱（柜）、洗衣机“三包”规定及承诺</p>\n' +
  // '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>'+
  // '1.美菱冰箱（柜）、洗衣机整机保修一年；主要零部件保修三年。\n' +'<br>\n' +
  // '2.备注：特殊活动期间的保修政策以活动说明和相关附加凭证为准。'+'<br>\n' +
  // '<img src="'+basepath+'static/fridge_instruction.png" style=\'width:100%;\' \/>'+
  //   '</div>'+
  // '<p style=\'font-size:18px;color:#333333;margin-top: 10px;\' id="outfridgerange">下列情况之一的，均不在“三包”范围之列：</p>\n'+
  // '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>'+
  // '1.因用户未能按照产品使用说明书要求运输、正常使用、操作、安装、维护、保管不当等原因造成产品损坏。\n'+'<br>\n' +
  // '2.非美菱授权服务商对产品维修、拆动造成损坏。\n'+'<br>\n' +
  // '3.无产品购买有效发票、凭证和“三包”凭证，以及三包”凭证的型号和编号与实际修理产品的型号和编号不符或涂改的。\n'+'<br>\n' +
  // '4.因不可抗力造成损失。\n'+'<br>\n' +
  // '5.其它不合国家法律、法规中规定的保修内容。'+
  // '</div>' +
  // '<p style=\'font-size:18px;color:#333333;margin-top: 10px;\' id="fridgstandard">冰箱/柜维修收费标准：</p>\n'+
  // '<img src="'+basepath+'static/fridge_cost_standard.png" style=\'width:100%;\' \/>'+
  // '<p style=\'font-size:14px;color:#333333;margin-top: 10px;\'>备注:</p>\n' +
  // '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>'+
  // '1.特种冰箱指——300L以上的冰箱或医院专用等其它特殊用途的冰箱（柜）。\n' +'<br>\n' +
  // '2.保外维修服务收费=维修费+服务费（搬动费和里程费）+材料费。\n'+
  //   '</div>'+
    // '<p style=\'font-size:18px;color:#333333;margin-top: 10px;\'>其他收费标准：</p>\n'+
    // '<img src="'+basepath+'static/fridge_other_cost_standard.png" style=\'width:100%;\' \/>'+
    // '<p style=\'font-size:18px;color:#333333;margin-top: 10px;\' id="washerservice">洗衣机收费标准：</p>\n'+
    // '<img src="'+basepath+'static/washer_cost_note.png" style=\'width:100%;\' \/>'+
    // '<p style=\'font-size:14px;color:#333333;margin-top: 10px;\'>备注:</p>\n' +
    // '<p style=\'font-size: 14px;color: #999999;line-height: 25px;\'>'+
    // '1.保外维修服务收费=维修费+服务费（搬动费和里程费）+材料费。\n'+
    // '</p>'+
  //   '<p style=\'font-size:18px;color:#333333;margin-top: 10px;\'>其他收费标准：</p>'+
  //   '<img src="'+basepath+'static/washer_othercost_note.png" style=\'width:100%;margin-bottom: 20px\' \/>'+
  // '<p style=\'font-size:18px;color:#333333;margin-top: 10px;margin-bottom:10px;\'>自检：</p>\n'+
  // '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>'+
  // '以实际设备情况为准，App检测只是辅助作用。'+
  '</div>'


};



// WEBPACK FOOTER //
// ./src/struction/fridge.js